<template>
  <header class="page-header" :class="{ open: menuOpen }">
    <div class="logo" v-scroll-to="'#scene-5'"></div>
    <Hamburger :open="menuOpen" @toggleClose="toggleMenu"/>
    <nav>
      <a
        v-for="(item, index) in menu"
        :key="index"
        v-scroll-to="item.link"
        @click="toggleMenu"
      >{{item.text}}</a>
    </nav>
  </header>
</template>

<script>
import Hamburger from '@/components/Hamburger.vue'
export default {
  name: 'PageHeader',
  data () {
    return {
      menuOpen: false,
      menu: [
        {
          text: 'Thank you',
          link: '#thanks'
        },
        {
          text: 'Sign',
          link: '#start-view'
        },
        {
          text: 'Tag',
          link: '#mobile-static'
        },
        {
          text: 'Open letter',
          link: '#letter-view'
        },
        {
          text: 'Independent by choice',
          link: '#tshirt-title'
        },
        {
          text: 'The independent report',
          link: '#booklet'
        },
        {
          text: 'Q&A',
          link: '#qa'
        },
        {
          text: 'About us',
          link: '#about'
        },
        {
          text: 'Press',
          link: '#press'
        },
        {
          text: 'Contact',
          link: '#press'
        }
      ]
    }
  },
  props: {
  },
  methods: {
    toggleMenu () {
      this.menuOpen = !this.menuOpen
    }
  },
  components: {
    Hamburger
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.page-header {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  z-index: 999;
}
nav {
  position: fixed;
  right: 0px;
  transform: translateX(100%);
  text-align: center;
  background-color: #000075;
  padding: 30px;
  height: 100vh;
  min-width: 25%;
  color: #ffff76;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  transition: all 0.3s ease;
  font-size: 1.3rem;
  font-weight: bold;
  a {
    display: block;
    color: #ffff76;
    padding: 10px;
    cursor: pointer;
    &:hover {
      background-color: transparent;
      color: #2effc3;
    }
  }
}
.open nav {
  transform: translateX(0%);
}
.hamburger {
  top: 16px;
  right: 30px;
  cursor: pointer;
  @media only screen and (max-width: 600px) {
    top: 8px;
    right: 15px;
  }
}
.logo {
  width: 195px;
  height: 65px;
  top: 24px;
  left: 24px;
  position: absolute;
  cursor: pointer;
  background-image: url("../assets/recordunion-logo.svg");
  background-repeat: no-repeat;
  background-size: contain;
  background-position: left center;
  @media only screen and (max-width: 1930px) {
    width: 180px;
    height: 50px;
    top: 20px;
    left: 20px;
  }
  @media only screen and (max-width: 1400px) {
    width: 180px;
    height: 46px;
    top: 20px;
    left: 20px;
  }
  @media only screen and (max-width: 600px) {
    width: 100%;
    height: 40px;
    left: 10px;
    top: 13px;
  }
}
</style>
